/**
 * Partículas sutis como background - movimento suave + leve follow no mouse
 */
(function() {
  const PARTICLE_SIZE = 2;
  const MOUSE_INFLUENCE = 0.03;
  const MOUSE_RADIUS = 180;

  function createParticles(section) {
    const canvas = section.querySelector('.aomai-particle-canvas');
    if (!canvas) return;

    const particleCount = parseInt(canvas.dataset.particleCount, 10) || 45;
    const ctx = canvas.getContext('2d');
    let animationId;
    let mouseX = -9999;
    let mouseY = -9999;

    const hexColor = canvas.dataset.particleColor || '#161616';
    function getParticleColor(opacity) {
      const r = parseInt(hexColor.slice(1, 3), 16);
      const g = parseInt(hexColor.slice(3, 5), 16);
      const b = parseInt(hexColor.slice(5, 7), 16);
      return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    }

    function setCanvasSize() {
      const rect = section.getBoundingClientRect();
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = rect.width * dpr;
      canvas.height = rect.height * dpr;
      canvas.style.width = rect.width + 'px';
      canvas.style.height = rect.height + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      return { width: rect.width, height: rect.height, dpr };
    }

    const particles = [];
    let width, height;

    function initParticles() {
      const size = setCanvasSize();
      width = size.width;
      height = size.height;
      particles.length = 0;

      // Camadas de profundidade: opacidades variadas para efeito de múltiplas camadas
      const layers = [
        { minOp: 0.03, maxOp: 0.07, minSize: 0.8, maxSize: 1.2 },   // fundo - bem sutil
        { minOp: 0.06, maxOp: 0.12, minSize: 1.2, maxSize: 1.8 },   // meio-fundo
        { minOp: 0.10, maxOp: 0.18, minSize: 1.5, maxSize: 2.2 },   // meio
        { minOp: 0.14, maxOp: 0.22, minSize: 1.8, maxSize: 2.5 },   // meio-frente
        { minOp: 0.18, maxOp: 0.28, minSize: 2, maxSize: 3 }        // frente - mais visível
      ];

      for (let i = 0; i < particleCount; i++) {
        const layer = layers[Math.floor(Math.random() * layers.length)];
        const sizeRange = layer.maxSize - layer.minSize;
        const opacityRange = layer.maxOp - layer.minOp;
        particles.push({
          x: Math.random() * width,
          y: Math.random() * height,
          vx: (Math.random() - 0.5) * 0.4,
          vy: (Math.random() - 0.5) * 0.4,
          size: layer.minSize + Math.random() * sizeRange,
          opacity: layer.minOp + Math.random() * opacityRange
        });
      }
    }

    function draw() {
      if (!ctx || !width || !height) return;

      ctx.clearRect(0, 0, width, height);

      particles.forEach(p => {
        // Drift suave
        p.x += p.vx;
        p.y += p.vy;

        // Wrap nas bordas
        if (p.x < 0 || p.x > width) p.vx *= -1;
        if (p.y < 0 || p.y > height) p.vy *= -1;
        p.x = Math.max(0, Math.min(width, p.x));
        p.y = Math.max(0, Math.min(height, p.y));

        // Influência sutil do mouse
        const dx = mouseX - p.x;
        const dy = mouseY - p.y;
        const dist = Math.sqrt(dx * dx + dy * dy);
        if (dist < MOUSE_RADIUS && mouseX > 0) {
          const force = (1 - dist / MOUSE_RADIUS) * MOUSE_INFLUENCE;
          p.x += dx * force;
          p.y += dy * force;
        }

        const color = getParticleColor(p.opacity);
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
        ctx.fillStyle = color;
        ctx.fill();
      });

      animationId = requestAnimationFrame(draw);
    }

    function onMouseMove(e) {
      const rect = section.getBoundingClientRect();
      mouseX = e.clientX - rect.left;
      mouseY = e.clientY - rect.top;
    }

    function onMouseLeave() {
      mouseX = -9999;
      mouseY = -9999;
    }

    section.addEventListener('mousemove', onMouseMove, { passive: true });
    section.addEventListener('mouseleave', onMouseLeave, { passive: true });

    const resizeObserver = new ResizeObserver(() => {
      initParticles();
    });
    resizeObserver.observe(section);

    initParticles();
    draw();

    return function cleanup() {
      cancelAnimationFrame(animationId);
      section.removeEventListener('mousemove', onMouseMove);
      section.removeEventListener('mouseleave', onMouseLeave);
      resizeObserver.disconnect();
    };
  }

  function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('.aomai-impact-text').forEach(section => {
      const canvas = section.querySelector('.aomai-particle-canvas');
      if (canvas && !canvas.dataset.particlesInit) {
        canvas.dataset.particlesInit = '1';
        createParticles(section);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }
})();
